import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
const InputEditIngresos=({type="number",onConfirm,placeholder="Agrega Valor", initial_value, onClose,inputSelected})=>{
    const [value,setValue] = useState(initial_value)
    return <Row>
        <Col lg={12} className="my-1">
            <input type={type} className='form-control input-sm' placeholder={placeholder} value={value} onChange={(e)=>setValue(e.target.value)}/>
        </Col>
        <Col>
            <button className='btn btn-sm btn-info mr-3' onClick={()=>onConfirm(value,inputSelected)}>Guardar</button>
            <button className='btn btn-sm btn-danger' onClick={onClose}>Cerrar</button>
        </Col>
    </Row>
}

export default InputEditIngresos